$(() => {
  $('[data-action="report-profile"]').on('click', (event) => {
    var influencer_name = $('[data-input="influencer-name"]').val();
    var influencer_id = $('[data-input="influencer-id"]').val();
    var modalWindow = modal.prompt('Message', "Report Problems with Profile - " + influencer_name, '');

    modalWindow.onDone((value) => {
      var form = $('[data-form="report-profile"]');

      if (value.length !== 0) {
        form.find('input').val(value);
        form.submit();
      }
      else {
        modal.
          alert(
            'Please write down the problem.!',
            'Warning'
          ).
          show();
      }
    });

    modalWindow.show()
  });
});

